import { render, staticRenderFns } from "./ProductEditMustHave.vue?vue&type=template&id=71bbd35a&"
import script from "./ProductEditMustHave.vue?vue&type=script&lang=js&"
export * from "./ProductEditMustHave.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports